import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/datenschutz")({
  head: () => ({
    meta: [
      { title: "Datenschutz, OM Selected" },
      { name: "description", content: "Datenschutzerklärung von OM Selected nach DSGVO und Schweizer DSG." },
      { name: "robots", content: "index, follow" },
      { property: "og:title", content: "Datenschutz, OM Selected" },
      { property: "og:description", content: "Datenschutzerklärung von OM Selected nach DSGVO und Schweizer DSG." },
      { property: "og:url", content: "https://omselected.art/datenschutz" },
    ],
    links: [{ rel: "canonical", href: "https://omselected.art/datenschutz" }],
  }),
  component: DatenschutzPage,
});

function DatenschutzPage() {
  return (
    <article className="mx-auto max-w-2xl px-5 md:px-10 py-20">
      <h1 className="serif text-4xl md:text-5xl mb-10">Datenschutz­erklärung</h1>

      <div className="space-y-6 text-sm leading-relaxed text-foreground/90">
        <p className="text-muted-foreground">
          Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}. Diese
          Erklärung informiert über Art, Umfang und Zweck der Verarbeitung personenbezogener Daten
          auf omselected.art im Sinne der DSGVO und des Schweizer DSG.
        </p>

        <h2 className="serif text-2xl mt-10">1. Verantwortlich</h2>
        <p>
          Vidhya Om, Steinentorstraße 18, 4051 Basel, Schweiz.<br />
          E-Mail: <a href="mailto:kontakt@omselected.art" className="underline">kontakt@omselected.art</a>
        </p>

        <h2 className="serif text-2xl mt-10">2. Zugriffsdaten</h2>
        <p className="text-muted-foreground">
          Beim Aufruf der Website werden technische Daten (IP-Adresse, User-Agent, Referrer,
          Zeitstempel) vom Hosting-Provider verarbeitet, soweit dies für die Auslieferung der
          Website erforderlich ist (Art. 6 Abs. 1 lit. f DSGVO). Diese Logs werden nach kurzer
          Zeit gelöscht.
        </p>

        <h2 className="serif text-2xl mt-10">3. Kontaktaufnahme</h2>
        <p className="text-muted-foreground">
          Bei Kontakt per E-Mail oder über unsere Formulare (Brief, Bewerbung) werden die
          angegebenen Daten zur Bearbeitung der Anfrage verarbeitet (Art. 6 Abs. 1 lit. b DSGVO).
          Die Daten werden gelöscht, sobald sie für den Zweck nicht mehr erforderlich sind und
          keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
        </p>

        <h2 className="serif text-2xl mt-10">4. Benutzerkonten</h2>
        <p className="text-muted-foreground">
          Für die Nutzung bestimmter Funktionen kann ein Konto angelegt werden. Wir verarbeiten
          E-Mail-Adresse und Profilangaben zur Bereitstellung der Funktion (Art. 6 Abs. 1 lit. b
          DSGVO). Konten können jederzeit gelöscht werden.
        </p>

        <h2 className="serif text-2xl mt-10">5. Hosting & Backend</h2>
        <p className="text-muted-foreground">
          Die Website wird auf einer Cloud-Infrastruktur betrieben. Datenbank, Authentifizierung
          und Datei-Speicherung erfolgen über Supabase (Supabase Inc.), das Hosting über
          Cloudflare. Mit den Anbietern bestehen Auftragsverarbeitungsverträge.
        </p>

        <h2 className="serif text-2xl mt-10">6. Cookies</h2>
        <p className="text-muted-foreground">
          Wir verwenden technisch notwendige Cookies (z. B. für die Anmeldung), die für den
          Betrieb der Website erforderlich sind. Analyse- oder Marketing-Cookies setzen wir nur
          mit Deiner ausdrücklichen Einwilligung über unser Cookie-Banner (Art. 6 Abs. 1 lit. a
          DSGVO). Die Einwilligung kann jederzeit unter{" "}
          <a href="/cookies" className="underline">/cookies</a> widerrufen werden.
        </p>

        <h2 className="serif text-2xl mt-10">7. Deine Rechte</h2>
        <p className="text-muted-foreground">
          Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
          Datenübertragbarkeit und Widerspruch. Außerdem steht Dir ein Beschwerderecht bei einer
          Aufsichtsbehörde zu (in der Schweiz: EDÖB; in der EU: die jeweils zuständige nationale
          Behörde).
        </p>

        <h2 className="serif text-2xl mt-10">8. Kontakt zum Datenschutz</h2>
        <p>
          Anfragen zum Datenschutz bitte an{" "}
          <a href="mailto:kontakt@omselected.art" className="underline">kontakt@omselected.art</a>.
        </p>
      </div>
    </article>
  );
}